import * as React from 'react';
import {LessonObject} from 'api/lesson/types';
import Card from './components/Card';

export interface RenderCardsProps {
  content: LessonObject['content'];
}

/**
 * This component renders content cards.
 */
export default class RenderCards
  extends React.Component<RenderCardsProps> {
  /**
   * Configure.
   * @param {RenderCardsProps} props
   */
  constructor(props: RenderCardsProps) {
    super(props);
  }

  /**
   * Render.
   * @return {JSX.Element}
   */
  render() {
    return this.props.content.map((content, index) => (
      <Card
        key={content.id}
        index={index}
        {...content}
      />
    ));
  }
}
